import kutil from "./kutil";


export interface Route {
  id: string;
  startPos: string;
  endPos: string;
}

export type Routes = {
  [key: string]: Route;
}

let routes: Routes = {};

async function reloadWorkRoutes() {
  if (workRoute.isInitialized) {
    return;
  }
  await initWorkRoutes();
}

async function initWorkRoutes() {
  try {
    workRoute.isInitialized = true;
    const data = await kutil.sendGet("/api/common/workRoute.data?mode=search", {}, {skipLoading: true});

    routes = {};
    (data.infos as any[]).map((info) => {
      const route: Route = {
        id: info.startPos + "," + info.endPos,
        startPos: info.startPos,
        endPos: info.endPos,
      };
      routes[route.id] = route;
    });
  } catch(e) {
    console.log(e);
    routes = {};
    workRoute.isInitialized = false;
  }
}

function isValid(startPos: string|number, endPos: string|number): boolean {
  const key = startPos + "," + endPos;
  return !!routes[key];
}

function validStarts(endPos: string|number): string[] {
  const validRoutes = Object.values(routes).filter(route => endPos == "" || route.endPos == "" + endPos).map(route => route.startPos);
  return [...new Set(validRoutes)].sort((a, b) => Number(a) - Number(b));
}

function validEnds(startPos: string|number): string[] {
  const validRoutes = Object.values(routes).filter(route => startPos == "" || route.startPos == "" + startPos).map(route => route.endPos);
  return [...new Set(validRoutes)].sort((a, b) => Number(a) - Number(b));
}

function getPos(pos: string|number, z: string|number, x: string|number, y: string|number): string {
  const _pos = kutil.toInt(pos, 0);
  if (_pos < 10) {
    return String(pos).padStart(2, "0") + String(z).padStart(3, "0") + String(x).padStart(3, "0") + String(y).padStart(2, "0");
  } else {
    return String(pos).padStart(3, "0");
  }
}

type WorkRoute = {
  isInitialized: boolean;
  reloadWorkRoutes: () => Promise<void>;
  initWorkRoutes: () => Promise<void>;
  isValid: (from: string|number, to: string|number) => boolean;
  validStarts: (endPos: string|number) => string[];
  validEnds: (startPos: string|number) => string[];
  getPos: (pos: string|number, z: string|number, x: string|number, y: string|number) => string;
};

const workRoute: WorkRoute = {
  isInitialized: false,
  reloadWorkRoutes,
  initWorkRoutes,
  isValid,
  validStarts,
  validEnds,
  getPos,
};

export default workRoute;
